import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=2cde774c"
import script from "./AboutModal.vue?vue&type=script&lang=ts"
export * from "./AboutModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cde774c')) {
      api.createRecord('2cde774c', component.options)
    } else {
      api.reload('2cde774c', component.options)
    }
    module.hot.accept("./AboutModal.vue?vue&type=template&id=2cde774c", function () {
      api.rerender('2cde774c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/AboutModal.vue"
export default component.exports